var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSizeMeasureSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44141 5.1875C4.68405 5.1875 5.69141 4.18014 5.69141 2.9375C5.69141 1.69486 4.68405 0.6875 3.44141 0.6875C2.19877 0.6875 1.19141 1.69486 1.19141 2.9375C1.19141 4.18014 2.19877 5.1875 3.44141 5.1875Z",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44141 15.312C4.68405 15.312 5.69141 14.3047 5.69141 13.062C5.69141 11.8194 4.68405 10.812 3.44141 10.812C2.19877 10.812 1.19141 11.8194 1.19141 13.062C1.19141 14.3047 2.19877 15.312 3.44141 15.312Z",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 5.18799C14.8051 5.18799 15.8125 4.18063 15.8125 2.93799C15.8125 1.69535 14.8051 0.687988 13.5625 0.687988C12.3199 0.687988 11.3125 1.69535 11.3125 2.93799C11.3125 4.18063 12.3199 5.18799 13.5625 5.18799Z",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 15.3125C14.8051 15.3125 15.8125 14.3051 15.8125 13.0625C15.8125 11.8199 14.8051 10.8125 13.5625 10.8125C12.3199 10.8125 11.3125 11.8199 11.3125 13.0625C11.3125 14.3051 12.3199 15.3125 13.5625 15.3125Z",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71484 2.896L11.2034 2.896",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44141 5.18799L3.44141 10.6765",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 5.18799L13.5625 10.6765",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71484 13.0205L11.2034 13.0205",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSizeMeasureSelected);
export default __webpack_public_path__ + "static/media/ico_size_measure_selected.f680a099a479a6b30fa38030430f142d.svg";
export { ForwardRef as ReactComponent };